<script>
import { get } from 'vuex-pathify'
export default {
	props: ['OrderSummary'],
	hookZone: ['after--default'],
	showHook(hookZone, ProductPage) {
		return true
	},
	computed: {
		totalPoints() {
			return (
				this.OrderSummary.order.items?.reduce((total, item) => {
					return total + (item.customData?.cruceroPoints || 0) * (item.qty || 1)
				}, 0) || 0
			)
		},
	},
}
</script>

<template>
	<div class="text-center font-2 price bold">
		Total Puntos Crucero: {{ totalPoints.toLocaleString('es-AR') }} Pts
	</div>
</template>

